/* eslint-disable */
import axios from "axios";
import "../utils/axios.interceptor";
import { format } from "date-fns";
import { urlCoreBack } from "../configs/config";

const epGetIngresocristal = "v1/ingreso-cristal/?";
const epGetIngresocristalListaPrecio = "v1/ingreso-cristal-lprecio/?";
const epIngresocristal = "v1/ingreso-cristal/";
const epGetTiposIngresoStock = "v1/tipo-Ingreso-stock/?";

const epNameEnvio = "v1/envio-cristal/?"
const epNamecristalByCodigo = "v1/cristal/"
const epNameEnviocristal = "v1/envio-cristal/";
const epNameRecibircristal = "v1/envio-cristal/recibir/";


const textNameIngresoStock = "Ingreso de Cristal";

const itemGender = "M";
const elLa = itemGender === "M" ? "el" : "la";
const unUna = itemGender === "M" ? "un" : "una";
//
// #############################################################################
//
export const getIngresosCristal = async (params) => {

  let _errorMessage = "Se produjo un error al obtener los Ingresos de Cristales";
  let _params = {};


  if (params.estadoActual) {
    if (params.estadoActual === "habilitado") {
      _params.habilitado = 'H';
    }

    if (params.estadoActual === "deshabilitado") {
      _params.habilitado = 'D';
    }
  }

  if (params) {

    if (params.codigo) {
      _params.codigo = params.codigo;
    }

    if (params.idArea) {
      _params.id_area = params.idArea;
    }

    if (params.idProveedor) {
      _params.id_proveedor = params.idProveedor;
    }

    if (params.idCristalProducto) {
      _params.id_cristal_producto = params.idCristalProducto;
    }

    if (params.idBlCrDiametro) {
      _params.id_bl_cr_diamtro = params.idBlCrDiametro;
    }

    if (params.idBlCrAdicion) {
      _params.id_bl_cr_adicion = params.idBlCrAdicion;
    }

    if (params.fechaCreacionDesde) {
      _params.fecha_creacion_desde = format(params.fechaCreacionDesde, "yyyy/MM/dd");
    }

    if (params.fechaCreacionHasta) {
      _params.fecha_creacion_hasta = format(params.fechaCreacionHasta, "yyyy/MM/dd");
    }

    if (params.rows) {
      _params.rows = params.rows;
    }

    if (params.first) {
      _params.first = params.first;
    }

  }

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epGetIngresocristal}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado 
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    let _message_code = response.data.message_code;
    if (_message_code === "err-caja-mdc-os-plan-invalid") {
      response.messageText = `El Plan de Obra Social no es válido`;
    } else {
      response.messageText = _errorMessage;
    }
    response.ok = false;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// ##########################################################################
//
export const getIngresoCristalListaPrecio = async (params) => {
  let _errorMessage = "Se produjo un error al obtener la lista de precios del Ingreso de Cristal";

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epGetIngresocristalListaPrecio}`,
      params: params
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }

      if (response.data.code === "err-cr-lprecio-not-exist") {
        response.ok = false;
        response.messageText = "No existe una lista de precios con las características dadas";
        response.messageSeverity = "warning";
        return response;
      }
    }

    // si hay error controlado lsalvador

    console.log(_errorMessage);
    console.log(response);

    response.messageText = _errorMessage;
    response.ok = false;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getIngresoCristal = async (parIdIngreso) => {
  let _errorMessage = "Se produjo un error al obtener el Ingreso de artículo";
  let _params = {};
  _params.id = parIdIngreso;
  _params.id_area = localStorage.getItem("id_area_deposito");


  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epGetIngresocristal}`,
      params: _params
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const saveIngresoCristal = async (parAction, parIngresoCristal) => {

  let _errorMessage = "";

  if (parAction === "new" || parAction === "update") {
    _errorMessage = "No fue posible guardar el Ingreso de Artículos";
  } else {
    _errorMessage = "No fue posible anular el Ingreso de Artículos";
  }
  parIngresoCristal.id_area = localStorage.getItem("id_area_deposito");
  parIngresoCristal.id_usuario = localStorage.getItem("id_usuario");

  try {

    let response = {};

    if (parAction === "new") {
      response = await axios({
        method: "POST",
        url: `${urlCoreBack}${epIngresocristal}`,
        data: parIngresoCristal,
      });
    } else if (parAction === "update") {
      response = await axios({
        method: "PUT",
        url: `${urlCoreBack}${epIngresocristal}`,
        data: parIngresoCristal,
      });
    } else {
      response = await axios({
        method: "DELETE",
        url: `${urlCoreBack}${epIngresocristal}`,
        params: parIngresoCristal,
      });
    }

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = `Ingreso de Cristales ${["new", "update"].includes(parAction) ? "guardado" : "anulado"}`;
        response.messageSeverity = "success";
        return response;
      }

      if (response.data.code === "err-ingreso-cristal-cantidad-disponible-insuficiente") {
        response.ok = false;
        response.messageText = "No es posible actualizar el Ingreso de artículo";
        response.messageSeverity = "error";
        return response;
      } else if (response.data.code === "err-ingreso-cristal-existencia-disponible-insuficiente") {
        response.ok = false;
        response.messageText = "La Cantidad disponible en el Área es insuficiente";
        response.messageSeverity = "error";
        return response;
      } else if (response.data.code === "err-ingreso-cristal-filas-list-required") {
        response.ok = false;
        response.messageText = "Debes Ingresar al menos un Cristal";
        response.messageSeverity = "error";
        return response;
      }
      // si hay error controlado

      console.log(_errorMessage);
      console.log(response);

      response.messageText = _errorMessage;
      response.ok = false;
      response.messageSeverity = "error";
      return response;
    }
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
}
//
// #############################################################################
//
export const getcristalByCodigo = async (codigo) => {
  let _errorMessage = `No fue posible obtener ${unUna} ${epNamecristalByCodigo} con el código ${codigo}`;

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epNamecristalByCodigo}`,
      params: {
        codigo: codigo
      }
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }

      // si hay error controlado

      console.log(_errorMessage);
      console.log(response);

      response.messageText = _errorMessage;
      response.ok = false;
      response.messageSeverity = "error";
      return response;
    }
  }
  catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
}
//
// #############################################################################
//
export const getcristal = async (id) => {
  let _errorMessage = `No fue posible obtener ${unUna} ${epNamecristalByCodigo}`;

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epNamecristalByCodigo}`,
      params: {
        id: id
      }
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }

      // si hay error controlado

      console.log(_errorMessage);
      console.log(response);

      response.messageText = _errorMessage;
      response.ok = false;
      response.messageSeverity = "error";
      return response;
    }
  }
  catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
}
